export default __webpack_public_path__ + "static/media/feature-emp-5.20eb1c65.png";